import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../../src/components/index';

class ModalRetornoOperacoesGet extends Component {
  modalContent = () => (
    <React.Fragment>
      <div className="row" style={{ height: this.props.estadoFormulario.papelUsuarioLogado === 'analista-dtp' ? '700px' : '400px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }}>
        <div className="row" >
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Protocolo Comprev"
              value={this.props.estadoFormulario.retorno.idProtocolo}
              disabled
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Protocolo Tarefa GET"
              value={this.props.estadoFormulario.retorno.idTarefaGet}
              disabled
            />
          </Grid>
          {this.props.estadoFormulario.retorno.idUnidadeOrganica != null &&
            <Grid cols="4 4 4 4">
              <Input
                style={{ color: '#00314d' }}
                label="UO de Criação da Tarefa GET"
                value={this.props.estadoFormulario.retorno.idUnidadeOrganica}
                disabled
              />
            </Grid>
          }
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Status Operação"
              value={this.props.estadoFormulario.retorno.status}
              disabled
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Operação"
              value={this.props.estadoFormulario.retorno.operacao}
              disabled
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Data de Inclusão"
              value={moment(this.props.estadoFormulario.retorno.dataInclusao).format('DD/MM/YYYY HH:mm:ss')}
              disabled
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Data de Envio"
              value={moment(this.props.estadoFormulario.retorno.dataEnvio).format('DD/MM/YYYY HH:mm:ss')}
              disabled
            />
          </Grid>
          {this.props.estadoFormulario.papelUsuarioLogado === 'analista-dtp' &&
            <Grid cols="4 4 4 4">
              <Input
                style={{ color: '#00314d' }}
                label="Origem"
                value={this.props.estadoFormulario.retorno.origem}
                disabled
              />
            </Grid>
          }
          {this.props.estadoFormulario.papelUsuarioLogado === 'analista-dtp' &&
          <Grid cols="4 4 4 4">
            <Input
              style={{ color: '#00314d' }}
              label="Quantidade de Tentativas"
              value={this.props.estadoFormulario.retorno.quantidadeTentativas}
              disabled
            />
          </Grid>
        }
        </div>
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              style={{ color: '#00314d' }}
              label="Mensagem"
              value={this.props.estadoFormulario.retorno.mensagem}
              disabled
            />
          </Grid>
        </div>
        {this.props.estadoFormulario.papelUsuarioLogado === 'analista-dtp' &&
          <div className="row">
            <Grid cols="12 12 12 12" >
              <Input
                style={{ color: '#00314d' }}
                disabled
                cols="50"
                componentClass="textarea"
                label="Body"
                maxlength="200"
                rows="6"
                value={this.props.estadoFormulario.retorno.body}
                textarea
              />
            </Grid>
          </div>
          }
        {this.props.estadoFormulario.papelUsuarioLogado === 'analista-dtp' &&
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                style={{ color: '#00314d' }}
                disabled
                cols="50"
                componentClass="textarea"
                label="Retorno"
                maxlength="200"
                rows="6"
                value={this.props.estadoFormulario.retorno.retorno}
                textarea
              />
            </Grid>
          </div>
          }
        {this.props.estadoFormulario.papelUsuarioLogado === 'analista-dtp' &&
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                style={{ color: '#00314d' }}
                disabled
                cols="50"
                componentClass="textarea"
                label="Observação:"
                maxlength="200"
                rows="4"
                value={this.props.estadoFormulario.retorno.observacao}
                textarea
              />
            </Grid>
          </div>
          }
      </div>
    </React.Fragment>
  )
  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          title="Fechar"
          onClick={this.handleClose}
          hint="Fechar"
        />
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.setState(this.props.handleModal('showDadosRetornoModal'));
  }
  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="lg"
        showModal={this.props.showModal}
        title="Detalhes do Registro da Operação"
      />
    );
  }
}

ModalRetornoOperacoesGet.propTypes = {
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default ModalRetornoOperacoesGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/ModalRetornoOperacoesGet.jsx